import "./fetcher.js";
import "#/shared/api/api-host-global.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotPickerModal ??= {};
window.AppointmentBooking.SlotPickerModal.Helpers ??= {};

AppointmentBooking.SlotPickerModal.Helpers.ResourceFetcher = class ResourceFetcher extends (
  AppointmentBooking.SlotPickerModal.Helpers.Fetcher
) {};

AppointmentBooking.SlotPickerModal.Helpers.ResourceFetcher.prototype.endpoint = window.Sparkle.apiHost
  ? window.Sparkle.apiHost + window.SparkleConfig.routes.embed.ehrAppointmentSlots
  : undefined;

AppointmentBooking.SlotPickerModal.Helpers.ResourceFetcher.prototype.api = "slot_picker_modal_resource";
